<h3>
  {{ header }}
  @if (lastIncrease) {
    <span>| Letzte Preiserhöhung: {{ lastIncrease.percent }} % - {{ lastIncrease.date_created }}</span>
  }
</h3>

<div class="inline-block pr-2">
  <button type="button" class="btn btn-link btn-after-headline" (click)="recalculate()">
    Preise aktualisieren
  </button>
</div>

@if (typ === 'de') {
  <price-detail-manual-increase [oaNr]="article.oa_nr" (updated)="reload.emit()">
  </price-detail-manual-increase>
}

@if (typ === 'cn') {
  <button type="button" class="btn btn-link btn-after-headline" style="margin-left: 20px;"
    (click)="setProducer(null)">
    Produzent festlegen
  </button>
}

<form [ngClass]="{'right-pad20': typ === 'de'}">
  <table class="table whitetable pricechecktable tablemiddle">
    <thead>
      <tr>
        <th class="right">&nbsp;</th>
        <th class="right">Menge</th>
        @if (typ === 'de') {
          <th class="right">K-Me</th>
          } <!-- DE only-->
          <th class="right">Lose</th>
          <th class="right">Freigabe</th>

          @if (typ === 'cn') {
            <th class="right">EK $</th>
            } <!-- CN only-->
            @if (typ === 'cn') {
              <th class="right">&nbsp;</th>
              } <!-- CN only-->

              <th class="right">
                @if (typ === 'de') {
                  <span>Einzel €</span>
                }
                @if (typ === 'cn') {
                  <span>VK €</span>
                }
              </th>

              @if (typ === 'cn') {
                <th class="right">Preis %</th>
                } <!-- CN only-->
                @if (typ === 'cn') {
                  <th class="right">GEK €</th>
                  } <!-- CN only-->
                  <th class="right">
                    @if (typ === 'de') {
                      <span>Gesamt €</span>
                    }
                    @if (typ === 'cn') {
                      <span>GVK €</span>
                    }
                  </th>

                  <th class="right">Kalk</th>
                  @if (typ === 'cn') {
                    <th class="right">Kurs</th>
                    } <!-- CN only-->
                    <th class="right">Datum</th>
                    <th class="right">Notiz</th>
                    <th colspan="6">&nbsp;</th>
                  </tr>
                </thead>
                @if (formListData) {
                  <tbody>
                    @for (obj of formListData; track trackByFn(index, obj); let index = $index) {
                      <tr [formGroup]="forms[obj.id.toString()]">
                        <td [ngClass]="{'greyed-out': !obj.approval}">
                          @if (!obj.valid) {
                            <i class="fa fa-exclamation-triangle"
                               title="gespeicherter Preis ist nicht mehr aktuell">
                            </i>
                          }
                        </td>
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">{{ obj.quanity }}</td>
                        <!-- DE only: start -->
                        @if (typ === 'de') {
                          <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                            {{ obj.calc_quanity }}
                            @if (!obj.calc_quanity) {
                              <span>{{ obj.quanity }}</span>
                            }
                          </td>
                        }
                        <!-- CN only: end -->
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">{{ obj.lose }}</td>
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                          {{obj.release}}
                        </td>
                        <!-- CN only: start -->
                        @if (typ === 'cn') {
                          <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                            @if ('price.change'|HasPerm) {
                              <input type="text" class="form-control"
                                [ngClass]="{red_alert: hasErrors(obj, 'cost')}"
                                formControlName="cost"
                                [tabindex]="(index * 3) + 1"
                                inputSelect>
                            }
                            @if (!('price.change'|HasPerm)) {
                              <span>{{ obj.cost }}</span>
                            }
                          </td>
                        }
                        @if (typ === 'cn') {
                          <td [ngClass]="{'greyed-out': !obj.approval}">
                            <button type="button"
                                    class="btn btn-link"
                                    [ngbTooltip]="(!obj.producer ? 'Produzenten auswählen' : `Produzenten auswählen: ${obj.producer}`)"
                                    (click)="setProducer(obj)">
                              <i class="fa fa-truck" [ngClass]="{'text-black': !obj.producer}"></i>
                            </button>
                          </td>
                        }
                        <!-- CN only: end -->
                        <td class="right bold" [ngClass]="{'greyed-out': !obj.approval}">{{ obj.single }}</td>
                        <!-- CN only: start -->
                        @if (typ === 'cn') {
                          <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                            <input type="text"
                              class="form-control"
                              formControlName="price_reduction"
                              [tabindex]="(index * 3) + 2"
                              [ngClass]="{'red_alert': hasErrors(obj, 'price_reduction')}"
                              inputSelect>
                          </td>
                        }
                        @if (typ === 'cn') {
                          <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                            {{obj.multi_cost}}
                          </td>
                        }
                        <!-- CN only: end -->
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval, 'red_alert': obj.is_red && typ === 'cn'}">
                          {{ obj.multi }}
                        </td>
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">{{ obj.calc }}</td>
                        <!-- CN only: start -->
                        @if (typ === 'cn') {
                          <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                            <input type="text"
                              class="form-control"
                              formControlName="exchange"
                              [tabindex]="(index * 3) + 3"
                              [ngClass]="{'red_alert': hasErrors(obj, 'exchange')}"
                              inputSelect>
                          </td>
                        }
                        <!-- CN only: end -->
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">{{ obj.date|date: "dd.MM.yyyy" }}</td>
                        <td class="right" [ngClass]="{'greyed-out': !obj.approval}">
                          @if (('price.change'|HasPerm)) {
                            <button type="button"
                                    class="btn btn-link btn-sm !text-storz-gray2"
                                    [title]="(!obj.notes ? 'Notiz bearbeiten' : `Notiz bearbeiten: ${obj.notes}`)"
                                    (click)="editNotes(obj)">
                              @if (!obj.notes) {
                                <i class="fa fa-1x fa-pencil"></i>
                              } @else {
                                <span class="notes-truncated">
                                  {{ obj.notes }}
                                </span>
                              }
                            </button>
                          }
                        </td>
                        <td class="right middle pricerelease-check" [ngClass]="{'greyed-out': !obj.approval, 'icon': typ === 'de', 'icon-lg': typ === 'cn'}">
                          @if (!obj.approval && 'price.change'|HasPerm) {
                            <button type="button"
                                    class="btn btn-sm btn-link"
                                    title="Preis freigeben"
                                    (click)="doApprove(obj)">
                              <i class="click fa fa-1x fa-check"></i>
                            </button>
                          }
                        </td>
                        <td [ngClass]="{'greyed-out': !obj.approval}">
                          @if (canRecalculate(obj)) {
                            <button type="button"
                                    class="btn btn-link"
                                    title="Preis neu berechnen"
                                    (click)="recalculateSingle(obj, index)">
                              <i class="fa fa-refresh"></i>
                            </button>
                          }
                        </td>
                        <td [ngClass]="{'greyed-out': !obj.approval}">
                          @if (!obj.valid) {
                            <button type="button"
                                    class="btn btn-link"
                                    title="Als manuellen Preis speichern"
                                    (click)="setManual(obj, index)">
                              <i class="fa fa-floppy-o"></i>
                            </button>
                          }
                        </td>
                        @if (typ === 'de') {
                          <td [ngClass]="{'greyed-out': !obj.approval}">
                            @if (obj.calc === 'manuell') {
                              <price-detail-manual-increase-single [oaNr]="obj.article"
                                                                   [price]="obj"
                                                                   (updated)="reload.emit()">
                              </price-detail-manual-increase-single>
                            }
                          </td>
                        }
                        <td [ngClass]="{'greyed-out': !obj.approval}">
                          <button type="button"
                                  class="btn btn-link"
                                  title="Preishistorie öffnen"
                                  (click)="openHistory(obj)">
                            <i class="fa fa-clock-o"></i>
                          </button>
                        </td>
                        <td [ngClass]="{'greyed-out': !obj.approval}">
                          <button type="button"
                                  class="btn btn-link"
                                  title="Preis löschen"
                                  (click)="deletePrice(obj)">
                            <i class="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </form>
